import { Chip, styled } from "@mui/material";
import { useMemo } from "react";

export enum ReleaseTrackStatusVariant {
  NOT_SUBMITTED = "not-submitted",
  SUBMITTED = "submitted",
  PENDING_REVIEW = "pending-review",
  VERIFIED_PASSED = "verified-passed",
  VERIFIED_FAILED = "verified-failed",
}

const variantToText: Record<ReleaseTrackStatusVariant, string> = {
  [ReleaseTrackStatusVariant.NOT_SUBMITTED]: "Not Submitted",
  [ReleaseTrackStatusVariant.SUBMITTED]: "Submitted",
  [ReleaseTrackStatusVariant.PENDING_REVIEW]: "Pending Review",

  [ReleaseTrackStatusVariant.VERIFIED_PASSED]: "Verified (Passed)",
  [ReleaseTrackStatusVariant.VERIFIED_FAILED]: "Verified (Failed)",
};

const ReleaseTrackStatusStyledChip = styled(Chip)(({ theme }) => ({
  borderRadius: "6px",
  [`&.${ReleaseTrackStatusVariant.PENDING_REVIEW}`]: {
    backgroundColor: theme.palette.pending.main,
    color: theme.palette.pending.contrastText,
  },
  [`&.${ReleaseTrackStatusVariant.VERIFIED_PASSED}`]: {
    backgroundColor: theme.palette.active.main,
    color: theme.palette.active.contrastText,
  },
  [`&.${ReleaseTrackStatusVariant.VERIFIED_FAILED}`]: {
    backgroundColor: theme.palette.releaseStatus.error.main,
    color: theme.palette.releaseStatus.error.contrastText,
  },
}));
export const ReleaseTrackStatus = ({
  variant = ReleaseTrackStatusVariant.NOT_SUBMITTED,
}: {
  variant: ReleaseTrackStatusVariant;
}) => {
  const textContent = useMemo(() => variantToText[variant], [variant]);

  return (
    <ReleaseTrackStatusStyledChip className={variant} label={textContent} />
  );
};
